import React from 'react';
import ServicePageTemplate from '../../../components/ServicePageTemplate/ServicePageTemplate';
import { getCategoryCatalog } from '../../../adapters/serviceCatalogAdapter';

const SpiritualServicesPage = ({ onNavigate }) => {
  const catalog = getCategoryCatalog('spiritual');

  return (
    <ServicePageTemplate
      serviceType="spiritual"
      services={catalog.services}
      filters={catalog.filters}
      pageConfig={catalog.pageConfig}
      onNavigate={onNavigate}
    />
  );
};

export default SpiritualServicesPage;

